/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';

/**
 *
 * @param { String } username - Username of the profile to fetch stats for
 * @param { Object } options
 * @param {Function | null | undefined} options.selector - Selects a value from the profile stats data
 * @param {Object | null | undefined} options.fallbackData - Data to fallback on
 * @returns {Object | SelectedValue}
 */
const useProfileStats = (
  username,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `v1/user/${username}/stats/`;

  const {
    data: profileStats,
    isValidating,
    ...rest
  } = useFetch(key, {}, { fallbackData: options.fallbackData });

  if (options.selector && typeof options.selector === 'function')
    return options.selector(profileStats || {});
  return {
    key,
    profileStats,
    isValidating,
    ...rest
  };
};

export default useProfileStats;
